export default __webpack_public_path__ + "static/media/E0006.ccd3df3c.png";